import { makeVar } from '@apollo/client'

export const isDepositDialogOpenVar = makeVar(false)
export const isWithdrawDialogOpenVar = makeVar(false)
export const isConfirmActionDialogOpenVar = makeVar(false)
export const isOperationSuccessDialogOpenVar = makeVar(false)
export const isOperationFailDialogOpenvar = makeVar(false)
export const isMintDialogOpenVar = makeVar(false)